/**
 * Clerk token bridge for API transport.
 * Transport runs outside React; a component inside ClerkProvider sets getToken so we can
 * send the Clerk session token as Bearer for production auth.
 */

let getTokenRef: (() => Promise<string | null>) | null = null;
let signOutRef: (() => Promise<void>) | null = null;

export function setClerkGetToken(fn: (() => Promise<string | null>) | null): void {
  getTokenRef = fn;
}

export function setClerkSignOut(fn: (() => Promise<void>) | null): void {
  signOutRef = fn;
}

export function getClerkSignOut(): (() => Promise<void>) | null {
  return signOutRef;
}

export async function getClerkToken(): Promise<string | null> {
  if (!getTokenRef) return null;
  try {
    return await getTokenRef();
  } catch {
    return null;
  }
}
